module.exports = __webpack_public_path__ + "img/yingyezhizhao.jpeg";